<template>
  <v-container fill-height class="py-16">
    <v-row no-gutters justify="center" class="d-block text-center">
      <v-img aria-label="User Not Allowed"
        src="../../assets/user_denied.svg"
        alt="user_denied"
        height="25vh"
        contain></v-img>
      <h1 class="text-h2 font-weight-thin pb-2">Oops!</h1>
      <h1 class="text-h4 font-weight-thin">Sorry friend, access denied</h1>
    </v-row>
    <v-row justify="center" class="col-12">
      <v-btn color="dw_green" light @click="$router.push({ name: 'playbook' })">
        Go Back to the Playbook
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'pageNotAllowed'
};
</script>
